import React from 'react';
import cx from 'classnames';
import { AddToCartButton } from '../AddToCartButton';

export const PackageCard = ({ pkg, className }) => {
  return (
    <div className={cx('package-card-container', className)}>
      <div
        className={cx(
          'package-card',
          `package-card--${pkg.region_name.toLowerCase()}`,
          'cursor-pointer'
        )}
        style={getBackgroundImageStyle(pkg)}
        onClick={() => {
          window.location = pkg.url;
        }}
      >
        <span className="text-smurfs-gold font-bold text-sm">
          {pkg.region_display_name}
        </span>
        <span className="text-h4 mt-2">{pkg.name}</span>
        <div className="flex mt-2 mb-2 z-10">
          <div className="line-through mr-2 text-50">
            USD {Number(pkg.old_price).toFixed(2)}
          </div>
          <div className="text-h4 text-smurfs-gold">
            USD {Number(pkg.price).toFixed(2)}
          </div>
        </div>
        {pkg.details.length === 0 ? (
          <div>
            {pkg.min_champions > 0 &&
              pkg.rank_id && (
                <div className="text-sm">
                  <i className="fas fa-check text-smurfs-gold mr-1" />
                  {pkg.min_champions}+ Champions
                </div>
              )}
            {pkg.min_champions > 0 ? (
              <div className="text-sm">
                <i className="fas fa-check text-smurfs-gold mr-1" />
                Hand Leveled
              </div>
            ) : (
              <div className="text-sm">
                <i className="fas fa-check text-smurfs-gold mr-1" />
                Fresh MMR
              </div>
            )}
            {pkg.min_blue_essence == 0 ? (
              <div className="text-sm">
                <i className="fas fa-check text-smurfs-gold mr-1" />Random
                amount of BE
              </div>
            ) : (
              <div className="text-sm">
                <i className="fas fa-check text-smurfs-gold mr-1" />
                {pkg.min_blue_essence}+ BE
              </div>
            )}
            <div className="text-sm">
              <i className="fas fa-check text-smurfs-gold mr-1" />Lifetime
              Warranty {pkg.rank_id || pkg.verified ? '' : '& Unverified Email'}
            </div>
          </div>
        ) : (
          pkg.details.map(detail => (
            <span className="text-sm">
              <i className="fas fa-check text-smurfs-gold mr-1" />{detail}
            </span>
          ))
        )}
        <div className="flex-1 flex justify-between items-end mt-5 whitespace-nowrap text-sm">
          <AddToCartButton
            product={{
              type: 'package',
              id: pkg.id,
              description: pkg.title,
              price: +pkg.price,
              url: pkg.url,
              regionName: pkg.region_name,
            }}
            className="btn-ghost btn-green"
            hideIcon
          />
          <a href={pkg.url} className="simple-btn btn-white btn-ghost">
            Acc. Details
          </a>
        </div>
      </div>
    </div>
  );
};

function getBackgroundImageStyle(pkg) {
  if (pkg.tier) {
    return {
      backgroundImage: `url(/images/packages/divisions/${pkg.tier}.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto 250px',
      backgroundPosition: 'calc(100% + 60px ) +20px',
    };
  }

  if (pkg.min_champions > 0) {
    return {
      backgroundImage: `url(/images/packages/champions/${
        pkg.region_name
      }-champion.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'auto 200px',
      backgroundPosition: 'calc(100% + 30px )',
    };
  }

  return {
    backgroundImage: `url(/images/packages/capsules/${
      pkg.region_name
    }-capsule.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(100% + 110px) -10px',
  };
}
